import styled from 'styled-components';

import { Accordion, spaceMixin } from '@zillow/constellation';

export const StyledAccordionItem = styled(Accordion.Item)`
  &:not(:last-child) {
    margin-bottom: ${spaceMixin('md')};
  }
`;
